<ng-container *ngIf="generalSettingsDataInput">
  <div class="sidebar-bg"></div>

  <div class="mobile-elements" [ngClass]="{'student-portal' : generalSettingsDataInput.userDetails.sessionSiteViewType === 1}">
    <div class="close-btn-box">
      <button class="no-style close-btn" (click)="closeSidebar()">
        <mat-icon [svgIcon]="'close'" class="square-icon close-icon"></mat-icon>
      </button>
    </div>

    <app-sidebar-account-info
      [generalSettingsData]="generalSettingsDataInput"
      (closeSidebar)="closeSidebar()"
    ></app-sidebar-account-info>

    <app-sidebar-my-links
      [generalSettingsData]="generalSettingsDataInput"
    ></app-sidebar-my-links>
  </div>

  <nav class="sidebar-nav" [ngClass]="{'student-portal' : generalSettingsDataInput.userDetails.sessionSiteViewType === 1}">
    <ul class="menu-ul">
      <li
        *ngFor="let item of generalSettingsDataInput.menuItems; let i = index"
        class="menu-li"
        [ngClass]="{ opened: item.opened }"
        id="main-menu-li-{{ i }}"
      >
        <a
          *ngIf="!item.external && !item.targetBlank"
          [routerLink]="item.subMenu && item.subMenu.length ? null : item.route"
          class="menu-link"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="toggleItem($event, item)"
          [class.active]="(item.route === '/' && i == 0 && (currentRoute === '/' || currentRoute===LocalizationService.getRoute(RoutesList.HomePage))) 
            || (item.route === '/en/' && i == 0 && (currentRoute === '/en' || currentRoute===LocalizationService.getRoute(RoutesList.HomePage))) 
            || isNestedNavElementActive(i)"
        >
          <mat-icon
            *ngIf="item.icon"
            [svgIcon]="item.title"
            class="menu-link-icon"
          ></mat-icon>
          <span class="menu-link-label">{{ item.title }}</span>
          <mat-icon
            *ngIf="item.subMenu && item.subMenu.length"
            [svgIcon]="'arrow-down'"
            class="square-icon menu-link-arrow"
          ></mat-icon>
        </a>
      
        <a
          *ngIf="item.external || item.targetBlank"
          [href]="item.subMenu && item.subMenu.length ? null : item.route"
          class="menu-link"
          [class.active]="isActiveExternalLink(item.route)"
          [target]="item.targetBlank ? '_blank' : '_self'"
        >
          <mat-icon
            *ngIf="item.icon"
            [svgIcon]="item.title"
            class="menu-link-icon"
          ></mat-icon>
          <span class="menu-link-label">{{ item.title }}</span>
        </a>
      
        <div
          *ngIf="item.subMenu && item.subMenu.length"
          [@openClose]="item.opened ? 'opened' : 'closed'"
          class="sub-menu"
        >
          <ul #menuUl class="menu-ul">
            <li *ngFor="let subItem of item.subMenu" class="menu-li">
              <a
                *ngIf="!subItem.external && !subItem.targetBlank"
                (click)="isMobile && closeSidebar()"
                [routerLink]="[subItem.route]"
                class="menu-link"
                [routerLinkActive]="'active'"
              >
                <span class="menu-link-label">{{ subItem.title }}</span>
              </a>
              <a
                *ngIf="subItem.external || subItem.targetBlank"
                [href]="subItem.route"
                class="menu-link"
                [class.active]="isActiveExternalLink(subItem.route)"
                [target]="subItem.targetBlank ? '_blank' : '_self'"
              >
                <span class="menu-link-label">{{ subItem.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    
    </ul>
  </nav>
</ng-container>


<ng-container *ngIf="!generalSettingsDataInput">
  <div class="sidebar-bg" aria-hidden="true"></div>

  <nav class="sidebar-nav skeleton" aria-hidden="true">
    <ul class="menu-ul">
      <li class="menu-li" *ngFor="let _ of [].constructor(10)">
        <div class="menu-link">
          <app-skeleton [height]="32" [width]="32" [borderRadius]="'50%'"/>
          <app-skeleton class="menu-link-label" [symbolsCount]="7" [type]="'text'"/>
        </div>
      </li>
    </ul>
  </nav>
</ng-container>
